import { AppContext } from '../models';
import { logoutAndRedirectToLogin } from './fsp-app-cookie.util';

export const readAppContext = (): AppContext => {
  const appContext: AppContext = JSON.parse(
    localStorage.getItem('fspAppContext'),
  );
  localStorage.removeItem('fspAppContext');
  if (!appContext) {
    logoutAndRedirectToLogin();
    throw new Error('Missing app context');
  }
  return appContext;
};
